const webConfig = {

    API_URL: process.env.REACT_APP_API_URL,

    PHONE: "6291000829",

    WHATSAPP: "6291000829",

    EMAIL: "consult@drnehaagarwalonco.com",

    HOSPITALS: [
        "Medica Superspecialty Hospital, Mukundapur",
        "Manipal Hospitals, EM Bypass",
        "Manipal Hospitals, Broadway",
        "Manipal Hospitals, Saltlake"
    ],

};

export default webConfig;